require('./services/client-cards');

module.exports = 'client-cards';


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/client-cards/index.js
 ** module id = 75
 ** module chunks = 1
 **/